import "./Warning.scss";

const Warning = () => {
    return (
        <div className="Warning">
            Base de datos neutralizada para pruebas. Los cambios no afectarán
            los datos finales.
        </div>
    );
};

export default Warning;
